
<template>
    <vs-select label="Branch" v-model="branch">
        <vs-select-item :key="index" :value="item.code" :text="item.name" v-for="(item,index) in filteredBranches" />
    </vs-select>
</template>
<script>
export default {
    name: "findSupplierComp",
    data () {
        return {
            branch: 1,
            access: [],
            branches: [{ code: 1, name:"Receptivo"}, {code: 2, name: "Cruceros"}]
        }
    },
    watch: {
        branch(val){
            console.log(val)
            this.$emit('onBranch', val)
        },
        access() {
            this.setDefaultBranch();
        }
    },
    created () {
        let currentUser = localStorage.getItem('asuspausr');
        currentUser = currentUser != null ? JSON.parse(atob(currentUser)) : null;
        if (currentUser != null) {
            
            this.access = currentUser.accesses; 
            this.setDefaultBranch();
        }
    },
    computed: {
        filteredBranches() {
            const access = this.access;

            const hasReceptivoAccess = access.some(a => [1, 2, 3, 4, 5].includes(a));
            const hasCrucerosAccess = access.some(a => [6, 7, 8, 9, 10].includes(a));

            return this.branches.filter(branch => {
                if (branch.code === 1 && hasReceptivoAccess) return true;
                if (branch.code === 2 && hasCrucerosAccess) return true;
                return false;
            });
        }
    },
    methods: {
        setDefaultBranch() {
            const filtered = this.filteredBranches;
            console.log('filtered', filtered);
            if (filtered.length > 0) {
                this.branch = filtered[0].code;
                console.log('===== here')
            }
        }
    },
    // methods: {
    //     async loadSuggestions(){
    //         this.suggestiondata = [];
    //         let response;
    //         if(this.flagType == 'Supplier'){
    //             response = await CatalogService.getSuppliers({ search: this.searchText});
    //         } else {
    //             response = await CatalogService.getAgencies({ search: this.searchText});
    //         }
    //         if((response.status/100) == 2){
    //             this.suggestiondata = response.data
    //         }
    //     },
    //     itemSelected(index){
    //         this.$emit('supplier', this.suggestiondata[index])
    //         if(!this.keepSearch){
    //             this.searchText = ""
    //         } else {
    //             this.searchText = this.suggestiondata[index].NAME
    //         }
    //         this.suggestiondata = [];
    //     },
    // }

}
</script>